<template>
  <div
    :class="{
      'pdt-anchor-section': true
    }"
  >
    <!-- 锚点 -->
    <div
      :id="name"
      style="height: 0px; overflow: hidden"
      class="pdt-anchor"
      :name="name"
      :title="title"
      :short-title="shortTitle || title"
    >
      <a :href="`#${name}`">{{ title }}</a>
    </div>
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'PdtAnchorSection',
  props: {
    name: { type: String, default: '' },
    title: { type: String, default: '' },
    shortTitle: { type: String, default: '' }
  },
  mounted() {
    this.$nextTick(() => {
      this.visible = this.expanded;
    });
  }
};
</script>

<style lang="scss">
.pdt-anchor-section {
  + .pdt-anchor-section {
    margin-top: 96px;
  }
}
</style>

<style lang="scss">
.page-layout_mobile .pdt-anchor-section {
  background: #f0f0f0;
  + .pdt-anchor-section {
    margin-top: 0px;
  }
}
</style>
